export default class Menu {
  constructor() {
    this.this = '#main-menu'
    this.$this = $(this.this)
    this.$mainMenu = $('#main-menu').find('.main-menu-ul')
    this.elementItem = '.hamburger-menu, html, #main-menu, #header'
    this.$header = $('#header, #main-menu-mobile')
    this.$hamburgerMenu = $('.hamburger-menu')
    this.li = this.$this.find('.main-menu-ul >li>a')
    this.liLevel1 = this.$this.find('.main-menu-ul >li')
    this.liLevel2 = this.$this.find('.main-menu-ul .main-menu-dropdown li>a')
    this.$bgOverShowMenu = this.$this.find('.bg-over-show-menu')
    this.anchorLink = $('.anchor-link-menu')
    this.japanHeader = $('.japan-header')
    this.isOpenMenu = 'is-open-menu'
    this.mainMenuDropdown = '.main-menu-dropdown'
    this.isOpenMenuChild = 'open-menu-child'
    this.isOpenChild = 'is-open-child'
    this.$linksInMenu = $('.header a:not(.skip-link), .header button')
    this.$firstLinkInMenu = this.$linksInMenu.first()
    this.$lastLinkInMenu = this.$linksInMenu.last()
    this.$skipLink = $('.header a.skip-link')
    this.ariaExpanded = 'aria-expanded'
    this.classHover = 'hovering'
    this.scrollDuration = 500
    this.$searchButton = $('.action-search button')
    this.$searchInput = $('.header-search-group input')
    this.formSearch = '#form-search'

    this.classes = {
      iconSearch: 'icon-icon-search',
      iconClose: 'icon-close',
      iconSearch2: '.search-icon',
      openHeaderSearch: 'open-header-search',
      isOpenSearch: 'is-open',
    };

    this.$searchIcon = this.$this.find('.navbar .search-icon');
    this.$searchHeader = $('.search-header');
    this.$searchElements = this.$searchHeader.find('input, button');
  }

  init() {
    if (this.$this.length) {
      this.replaceLinkMenu()
      this.openMainMenu()
      this.clickArrowOpenDropdownMenuLevel1()
      this.clickLiOpenDropdownMenuLevel1()
      this.clickArrowOpenDropdownMenuLevel2()
      this.clickOutSite()
      this.clickLiOpenDropdownMenuLevel2()
      this.toggleTabIndexSkipLink()
      this.hoverOpenMenu()
      this.scrollMenu()
      this.checkActiveMenu()
      this.clickJapanHeader()
      this.$mainMenu.addClass('js-loaded')
      this.setupSearchToggle()
    }
  }

  setupSearchToggle() {
    this.$searchHeader.removeClass('hidden');
    this.$searchElements.attr('tabindex', -1);

    this.$searchButton.on('click', (e) => {
      const $icon = $(e.currentTarget).find(this.classes.iconSearch2);
      const $searchInput = $(this.formSearch);

      if ($(window).outerWidth() < 1200) {
        if ($icon.hasClass(this.classes.iconSearch)) {
          $icon.removeClass(this.classes.iconSearch).addClass(this.classes.iconClose);
          this.$searchHeader.removeClass('is-open').addClass(this.classes.openHeaderSearch);
          this.$searchElements.attr('tabindex', 0);
          $searchInput.focus();

          if ($(this.elementItem).hasClass(this.isOpenMenu)) {
            $(this.elementItem).removeClass(this.isOpenMenu);
            this.$hamburgerMenu.attr(this.ariaExpanded, false);
          }
        } else {

          $icon.removeClass(this.classes.iconClose).addClass(this.classes.iconSearch);
          this.$searchHeader.removeClass('is-open open-header-search');
          this.$searchElements.attr('tabindex', -1);
          $searchInput.blur();
        }
      }
    });

    this.$hamburgerMenu.on('click', () => {
      if (this.$searchHeader.hasClass(this.classes.openHeaderSearch)) {
        const $icon = this.$searchButton.find(this.classes.iconSearch2);
        $icon.removeClass(this.classes.iconClose).addClass(this.classes.iconSearch);
        this.$searchHeader.removeClass('is-open open-header-search');
        this.$searchElements.attr('tabindex', -1);
        $(this.formSearch).blur();
      }
    });

    $(document).on('click', (event) => {
      if (!$(event.target).closest(this.$searchButton).length && !$(event.target).closest(this.formSearch).length) {
        const $icon = this.$searchButton.find(this.classes.iconSearch2);
        this.$searchHeader.removeClass(this.classes.openHeaderSearch);
        $icon.removeClass(this.classes.iconClose).addClass(this.classes.iconSearch);
        $(this.formSearch).blur();
        this.$searchElements.attr('tabindex', -1);
      }
    });
  }

  clickJapanHeader() {
    this.japanHeader.find('.link-no-href').on('click', (e) => {
      const $elm = $(e.currentTarget);
      const $parentLi = $elm.closest('li');
      const $parentLink = $elm.find('> a');
      if ($parentLi.hasClass(this.isOpenMenuChild)) {
        $parentLi.removeClass(this.isOpenMenuChild);
        $parentLink.attr(this.ariaExpanded, 'false');
      } else {
        this.japanHeader.find(`.${this.isOpenMenuChild}`).each((_, el) => {
          $(el).removeClass(this.isOpenMenuChild);
          $(el).find('> a').attr(this.ariaExpanded, 'false');
        });

        $parentLi.addClass(this.isOpenMenuChild);
        $parentLink.attr(this.ariaExpanded, 'true');
      }
    });
  }

  checkActiveMenu() {
    this.anchorLink.removeClass('active');
    this.initScrollPositions();
    this.bindAnchorLinkEvents();
    this.handleInitialHashScroll();
  }

  initScrollPositions() {
    this.positions = {
      anchorLink: 200,
      anchorRes: 400,
    };

    if ($(window).innerWidth() > 1199 && $(window).innerWidth() < 1600) {
      this.positions.anchorLink = 200;
      this.positions.anchorRes = -150;
    } else if ($(window).innerWidth() > 1599) {
      this.positions.anchorRes = 250;
    } else if ($(window).innerWidth() < 768) {
      this.positions.anchorRes = 50;
    } else {
      this.positions.anchorLink = 80;
      this.positions.anchorRes = 0;
    }
  }

  scrollToSection(targetId) {
    const cleanId = targetId.replace(/[^\w-]/g, '');
    const $targetSection = $(`#${cleanId}`);
    if (!$targetSection.length) { return };

    window.history.pushState(null, '', `#${targetId}`);
    const scrollTop = $targetSection.hasClass('item-lr-landing')
      ? $targetSection.offset().top + this.positions.anchorRes
      : $targetSection.offset().top - this.positions.anchorLink;

    $('html, body').animate({ scrollTop }, this.scrollDuration);
  }

  handleMenuClick(e) {
    const $currentTarget = $(e.currentTarget);
    const href = $currentTarget.attr('href');

    // If it's an external link, allow default behavior
    if (this.isExternalLink(href)) {
      return true;
    }

    // Prevent default behavior for internal links
    e.preventDefault();
    // Handle the internal navigation
    this.temporarilyDisableBgOver();
    const targetId = href.replace('#', '');
    this.scrollToSection(targetId);
    // Return false to indicate we handled the click
    return false;
  }

  isExternalLink(href) {
    if (href.includes('/') && href.includes('#')) {
      const [pathPart, hashPart] = href.split('#');
      if (window.location.pathname === pathPart) {
        this.scrollToSection(hashPart);
        this.temporarilyDisableBgOver();
        return false;
      }
      return true;
    }
    return href.includes('/');
  }

  temporarilyDisableBgOver() {
    this.$bgOverShowMenu.css({ 'height': '0', 'pointer-events': 'none' });
    setTimeout(() => {
      this.$bgOverShowMenu.css({ 'height': '', 'pointer-events': '' });
    }, 300);
  }

  handleInitialHashScroll() {
    const idUrl = window.location.hash.replace('#', '');
    if (idUrl) {
      setTimeout(() => this.scrollToSection(idUrl), 300);
    }
  }

  bindAnchorLinkEvents() {
    this.anchorLink.find('a').on('click', (e) => this.handleMenuClick(e));
  }

  scrollMenu() {
    $(window).on('scroll', (_e) => {
      if ($(window).innerWidth() > 1199) {
        $(this.mainMenuDropdown).css({
          'pointer-events': 'none',
          'opacity': 0,
        })
        $(`.${this.classHover}`).removeClass(this.classHover)
        setTimeout(() => {
          $(this.mainMenuDropdown).css({
            'pointer-events': '',
            'opacity': 1,
          })
        }, 3000)
      }
    })
  }

  // replace link menu
  replaceLinkMenu() {
    $('.link-no-href').each((_index, element) => {
      $(element).find('>a').attr('href', '#').on('click', (e) => e.preventDefault());
    });
  }

  /* micro function */
  microOpenCloseLevel1(currentElement, openClass, isLiLv1 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parent()

    eleParent.removeClass(this.classHover)
    this.$bgOverShowMenu.css('height', 0)
    if ($(window).width() < 1200) {
      if (eleParent.find('ul').length && !eleParent.hasClass(openClass)) {
        this.liLevel1.removeClass(openClass)
        this.liLevel1.find('> a').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv1) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }

    return true
  }
  /* end micro */

  openMainMenu() {
    this.$header.on('click', '.hamburger-menu', (e) => {
      const ele = e.currentTarget

      if ($(ele).hasClass(this.isOpenMenu)) {
        $(this.elementItem).removeClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Open menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, false)
        this.$skipLink.removeAttr('tabindex')
      } else {
        $(this.elementItem).addClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Close menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, true)
        this.bindEventFocusOnMenu()
      }
    })
  }

  toggleTabIndexSkipLink() {
    $(window).on('resize', () => {
      if ($(window).outerWidth() < 992) {
        this.$skipLink.removeAttr('tabindex')
      }
    })
  }

  bindEventFocusOnMenu() {
    this.$skipLink.attr('tabindex', -1)
    this.$firstLinkInMenu.get(0).addEventListener('keydown', this.shiftTabFocusToLast.bind(this))
    this.$lastLinkInMenu.get(0).addEventListener('keydown', this.tabFocusToFirst.bind(this))
  }

  tabFocusToFirst(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && !e.shiftKey) {
      e.preventDefault()
      this.$firstLinkInMenu.focus()
    }
  }

  shiftTabFocusToLast(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && e.shiftKey) {
      e.preventDefault()
      this.$lastLinkInMenu.focus()
    }
  }

  clickArrowOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', '.arrows-lv1', (e) => {
      this.microOpenCloseLevel1(e, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel1() {
    this.li.on('click', (e) => this.microOpenCloseLevel1(e, this.isOpenChild, true))
  }

  clickArrowOpenDropdownMenuLevel2() {
    this.$this.find('.main-menu-ul').on('click', '.arrows-lv2', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      if ($(window).width() < 1025) {
        if (eleParent.find('.menu-child').length && !eleParent.hasClass(this.isOpenMenuChild)) {
          eleParent.addClass(this.isOpenMenuChild)
        } else {
          eleParent.removeClass(this.isOpenMenuChild)
        }
      }
    })
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest('#header.is-open-menu').length) {
        $(this.elementItem).removeClass(this.isOpenMenu);
        if ($(window).outerWidth() < 1200) {
          this.liLevel1.removeClass(this.isOpenMenuChild);
          this.liLevel2.removeClass(this.isOpenMenuChild);
        }
      }
    })
  }

  clickLiOpenDropdownMenuLevel2() {
    this.liLevel2.on('click', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      this.closeAllSubmenu();
      $(this.elementItem).removeClass(this.isOpenMenu);
      if ($(window).width() < 1200 && eleParent.find('ul').length && !eleParent.hasClass(this.isOpenMenuChild)) {
        this.li.removeClass(this.isOpenMenuChild)
        eleParent.addClass(this.isOpenMenuChild)
        return false
      }
      return true
    })
  }

  closeAllSubmenu() {
    const $liHover = this.$this.find('.main-menu-ul>li.hovering')
    $liHover.removeClass('hovering')
    if ($liHover.hasClass('has-sub')) {
      $liHover.find('> a').attr(this.ariaExpanded, false)
    }
  }

  closeSearch() {
    if (this.$searchHeader.hasClass(this.classes.isOpenSearch)) {
      this.$searchHeader.removeClass(this.classes.isOpenSearch);
      $(this.formSearch).blur();
    }
  }

  hoverOpenMenu() {
    const classHoverHeader = 'pin-color'
    let timeout
    let timeHeader
    let submenuTimeout
    let isSubmenuOpen = false;
    // Add focus handling for top-level menu items
    this.li.on('focus', (e) => {
      const $parentLi = $(e.currentTarget).closest('li');
      if ($(window).outerWidth() > 1199) {
        this.closeSearch();
        clearTimeout(timeout);
        clearTimeout(timeHeader);
        clearTimeout(submenuTimeout);
        this.$bgOverShowMenu.css('height', $parentLi.find(this.mainMenuDropdown).innerHeight());
        this.closeAllSubmenu();
        $parentLi.addClass(this.classHover);
        if ($parentLi.hasClass('has-sub')) {
          $parentLi.find('> a').attr(this.ariaExpanded, true);
        }
        isSubmenuOpen = true;
      }
    });

    // Keep menu open when focusing on child items
    this.$this.find('.main-menu-dropdown a').on('focus', (e) => {
      if ($(window).outerWidth() > 1199) {
        const $parentTopLi = $(e.currentTarget).closest('.main-menu-ul > li');
        if ($parentTopLi.length) {
          this.$bgOverShowMenu.css('height', $parentTopLi.find(this.mainMenuDropdown).innerHeight());
          this.closeAllSubmenu();
          $parentTopLi.addClass(this.classHover);
          if ($parentTopLi.hasClass('has-sub')) {
            $parentTopLi.find('> a').attr(this.ariaExpanded, true);
          }
        }
      }
    });

    this.liLevel1.on('mouseover', (e) => {
      const ele = e.currentTarget;

      if ($(window).outerWidth() > 1199) {
        this.closeSearch();
        clearTimeout(timeout);
        clearTimeout(timeHeader);
        clearTimeout(submenuTimeout);

        if (isSubmenuOpen) {
          submenuTimeout = setTimeout(() => {
            this.$bgOverShowMenu.css('height', $(ele).find(this.mainMenuDropdown).innerHeight());
            this.closeAllSubmenu();
            $(ele).addClass(this.classHover);
            if ($(ele).hasClass('has-sub')) {
              $(ele).find('> a').attr(this.ariaExpanded, true);
            }
          }, 300);
        } else {
          this.$bgOverShowMenu.css('height', $(ele).find(this.mainMenuDropdown).innerHeight());
          $(this.mainMenuDropdown).css({
            'pointer-events': '',
            'opacity': 1,
          });
          timeout = setTimeout(() => {
            this.closeAllSubmenu();
            this.closeSearch();
            $(ele).addClass(this.classHover);
            if ($(ele).hasClass('has-sub')) {
              $(ele).find('> a').attr(this.ariaExpanded, true);
            }
          }, 10);
        }

        isSubmenuOpen = true;
      }
    });

    this.$mainMenu.on('mouseleave', () => {
      if ($(window).outerWidth() > 1199) {
        clearTimeout(timeout);
        clearTimeout(timeHeader);
        clearTimeout(submenuTimeout);
        submenuTimeout = setTimeout(() => {
          this.closeAllSubmenu();
          isSubmenuOpen = false;
        }, 300);
        timeHeader = setTimeout(() => {
          this.$header.removeClass(classHoverHeader);
          this.closeAllSubmenu();
          this.$bgOverShowMenu.css('height', '');
        }, 300);
      }
    });

    $(window).on('keydown', (e) => {
      if (e.keyCode === 27) {
        clearTimeout(timeout);
        clearTimeout(timeHeader);
        clearTimeout(submenuTimeout);
        this.closeAllSubmenu();
        this.$bgOverShowMenu.css('height', '');
        this.$header.removeClass(classHoverHeader);
        isSubmenuOpen = false;
        // If mobile menu is open, close it
        if ($(this.elementItem).hasClass(this.isOpenMenu)) {
          $(this.elementItem).removeClass(this.isOpenMenu);
          this.$hamburgerMenu.find('.sr-only').text('Open menu');
          this.$hamburgerMenu.attr(this.ariaExpanded, false);
          this.$skipLink.removeAttr('tabindex');
        }
      }
    });

    // Add focusout handler for the main menu
    this.$mainMenu.on('focusout', (e) => {
      // Check if the new focus target is outside the main menu
      const $newFocusTarget = $(e.relatedTarget);
      if (!this.$mainMenu.has($newFocusTarget).length && $(window).outerWidth() > 1199) {
        clearTimeout(timeout);
        clearTimeout(timeHeader);
        clearTimeout(submenuTimeout);
        this.closeAllSubmenu();
        this.$bgOverShowMenu.css('height', '');
        this.$header.removeClass(classHoverHeader);
        isSubmenuOpen = false;
      }
    });
  }
}

new Menu().init()
